export default function User() {
  this.email = ''
  this.password = ''
  this.name = ''
  this.phone = ''
  this.companyName = ''
  this.title = ''
}